import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
	'inline-flex items-center justify-center gap-2 whitespace-nowrap text-lg font-medium font-button ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 rounded-none',
	{
		variants: {
			variant: {
				default: 'bg-black text-white hover:bg-black/90',
				destructive: 'bg-red-600 text-white hover:bg-red-500',
				outline:
					'border border-gray-500 text-gray-900 hover:bg-[#A21B1F] hover:text-white hover:border-[#A21B1F]',
				secondary: 'bg-[#A21B1F] text-white hover:bg-[#A21B1F]/90 hover:text-black',
				ghost: 'bg-transparent text-gray-900 hover:bg-background-muted dark:text-white',
				link: 'text-gray-700 underline-offset-4 hover:text-accent dark:text-gray-500',
			},
			size: {
				default: 'h-10 px-5 py-4',
				sm: 'h-9 px-4 py-3',
				lg: 'h-11 px-10 py-4',
				icon: 'size-10 p-0',
			},
			block: {
				true: 'w-full',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	},
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
